import { produce } from 'immer';
import * as types from './constants';

// initial state
export const initialState = {
  runQuery: false,
  layout: null,
  clearColumnsQuery: false,
  clearQuery: false,
  exportQuery: false,
  saveQuery: false,
  shareQuery: false,
  disabledExportQuery: true,
  disabledSaveQuery: true,
  disabledRunQuery: true,
  editQuery: false,
  cancelQuery: false,
};

const ribbonAdvancedSearchReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.RUN_QUERY:
        draft.runQuery = action.runQuery;
        break;
      case types.UPDATE_LAYOUT_ADVANCED_SEARCH:
        draft.layout = action.layout;
        break;
      case types.CLEAR_COLUMNS_QUERY:
        draft.clearColumnsQuery = action.clearColumnsQuery;
        break;
      case types.CLEAR_QUERY:
        draft.clearQuery = action.clearQuery;
        break;
      case types.EXPORT_QUERY:
        draft.exportQuery = action.exportQuery;
        break;
      case types.SAVE_QUERY:
        draft.saveQuery = action.saveQuery;
        break;
      case types.SHARE_QUERY:
        draft.shareQuery = action.shareQuery;
        break;
      case types.EDIT_QUERY:
        draft.editQuery = action.editQuery;
        break;
      case types.CANCEL_QUERY:
        draft.cancelQuery = action.cancelQuery;
        break;
      case types.DISABLED_EXPORT_QUERY:
        draft.disabledExportQuery = action.disabledExportQuery;
        break;
      case types.DISABLED_SAVE_QUERY:
        draft.disabledSaveQuery = action.disabledSaveQuery;
        break;
      case types.DISABLED_RUN_QUERY:
        draft.disabledRunQuery = action.disabledRunQuery;
        break;
      default:
        break;
    }
  });

export default ribbonAdvancedSearchReducer;
